import { applyTransparent } from "../helper/applyTransparent";
import { AppTheme } from "./theme";

export const DEFAULTS = {
  // styles
  borderWidth: 1,
  borderColor: AppTheme.greyGoose,
  fontSize: 16,

  // toast
  toastDuration: 5000,
  toastFontSize: "16px",
  toastPadding: "15px",
  toastActionFontSize: "16px",
  toastContainerMinWidth: "400px",
  toastContentColGap: 10,

  // query
  staleTime: 10000,

  // seprators
  separatorSize: 1,

  // queries
  initialPage: 1,

  // deferred time
  deferredTime: 1000,

  // shadows
  shadowBlurSm: 15,
  shadowSpreadSm: 5,

  shadowBlurMd: 30,
  shadowSpreadMd: 10,

  shadowBlurLg: 50,
  shadowSpreadLg: 15,

  shadowColor: applyTransparent(AppTheme.greyGoose, 80),
};
